<script setup lang="ts">
    import { defineProps } from "vue";
    interface Props {
        img: string,
        nivel?: string,
        carrera?: string,
        complemento?: string,
        frase?: string,
        autor?: string,
        engop1?: string,
        engop2?: string,
        engop3?: string,
        engop4?: string,
        continua?: string
    }
    import { onMounted, ref } from "vue";
    let isAnimating = ref(false)
    onMounted(() => {
        setTimeout(() => { isAnimating.value= true }, 50);
    });


    defineProps<Props>();
</script>

<template>
    <section class="flex pt-[88px] lg:pt-[150px] justify-center min-h-[250px] h-full items-center mb-12 w-screen flex-col" style=" min-height:250px">
        <div fetchpriority="high" class="flex items-center justify-center w-screen min-h-[250px] h-full bg-center bg-cover md:bg-[center-right] bg-no-repeat" :style="img">
            <div class="flex justify-center w-full">
                <div class="flex text-justify w-full justify-center md:justify-start items-center max-w-4xl lg:max-w-[1200px] bg-white/50 md:bg-transparent">
                    <div id="animatedBox" :class="['w-full box h-fit md:h-[500px] md:w-[60%] lg:w-[45%] flex my-12 md:my-0 flex-col justify-center lg:px-0 px-8', { 'visible': isAnimating }]">
                        <h1 v-if="(nivel || carrera) && !continua" class="mb-2 text-black md:text-gray-600">
                            <span v-if="nivel" class="block font-sans text-hwine font-normal mb-0 md:text-[30px] text-[26px]">
                                {{ nivel }}
                            </span>
                            <span v-if="carrera" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="carrera" class="block font-serif text-hwine md:text-[50px] text-[46px]">
                                {{ carrera }}
                            </span>
                            <span v-if="complemento" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="complemento" class="font-serif text-hwine md:text-[36px] text-[32px] mb-2">
                                {{ complemento }}
                            </span>
                        </h1>
                        <p v-if="continua" class="mb-2 text-black md:text-gray-600">
                            <span v-if="nivel" class="block font-sans text-hwine font-normal mb-0 text-[30px]">
                                {{ nivel }}
                            </span>
                            <span v-if="carrera" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="carrera" class="block font-serif text-hwine text-[50px]">
                                {{ carrera }}
                            </span>
                            <span v-if="complemento" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="complemento" class="font-serif text-hwine text-[36px] mb-2">
                                {{ complemento }}
                            </span>
                        </p>
                        <p v-if="frase" class="text-black md:text-gray-600 font-times text-left text-[19px]">"{{ frase }}."</p>
                        <p v-if="autor" class="text-black md:text-gray-600 font-times text-right italic">-{{ autor }}-</p>
                        <h1 v-if="engop1 || engop2" class="mb-2 text-black md:text-gray-600">
                            <span v-if="engop1" class="block text-hgold text-[30px]">{{ engop1 }}</span>
                            <span v-if="engop2" class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span v-if="engop2" class="block font-serif text-hgold text-[50px]">{{ engop2 }}</span>
                        </h1>
                        <p v-if="engop3" class="text-black md:text-white font-serif italic text-[28px] mb-4">{{ engop3 }}</p>
                        <h2 v-if="engop4" class="text-black md:text-white font-serif text-[19px] mb-8 italic">{{ engop4 }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.box {
  transform: translateX(-160%); /* Fuera del viewport */
    transition: transform 1.2s ease-in-out;
}

.box.visible {
  transform: translateX(0); /* Posición original */
}
</style>